<template>
    <label class="flex-form__field">
        <div class="flex-form__label">
            Smooth Scroll
        </div>

        <div class="flex-form__toggle">
            <div class="flex-form__toggle-control">
                <toggle v-model="dataNew.smooth" />
            </div>
        </div>
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'action-scroll-to-top',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                smooth: {
                    type: Boolean,
                    default: true,
                },
            },
        };
    },
};
</script>
